<template>
  <div>
    <!--------------
      DataProvider
    --------------->
    <DataProvider id="id-wordcloud" :endpoint='mountUrlAndParams("notUnderstandInformationCloudWords").url' baseUrl='/placeholder'
        :filter='mountUrlAndParams("notUnderstandInformationCloudWords").filter' @success='mountChartData($event)' @search-query='handleSearch' class="md-layout-item">
        <!-- eslint-disable -->
        <div slot-scope='{ data: response, error, loading }'>
          <SkeletonLoaderChart v-if="loading" />
          <template v-else-if='error'>
            <CardNoData :title="$t('messagesNotUnderstood.wordCloud')" :error='error' height='408' />
          </template>
          <chart-card v-else header-animation="false" header-icon no-footer background-color="green" :isChart='false' class="md-layout-item">
            <template slot="chartInsideHeader">
              <div class="card-icon">
                <i class="fa-solid fa-cloud"></i>
              </div>
              <h4 class="title">{{ $t('messagesNotUnderstood.wordCloud') }}</h4>
              <!-------------------
                NUVEM DE PALAVRAS
              --------------------->
              <wordcloud
                :data="wordsCloud"
                nameKey="text"
                valueKey="value"
                :wordPadding="6"
                :color="myColors"
                :showTooltip="false"
                :wordClick="wordClickHandler"
                :fontSize="[20, 140]"
                :rotate="{from: -0, to: 0, numOfOrientation: 0}"
                font="Roboto"
                style="cursor: pointer; background-color: #FFF;"
              />
              <div v-if="wordsToSearch.length > 0" class="d-flex">
                <v-chip
                  v-for="(word, index) in wordsToSearch"
                  :key="index"
                  large
                  class="chip-filter"
                  close
                  color="#3D933C"
                  text-color="#ffffff"
                  close-icon="mdi-close"
                  @click:close="removeWord(word)">
                  {{word}}
                </v-chip>
                <div class="d-flex align-center" @click="removeAllWords()">
                  <v-icon>
                    mdi-refresh
                  </v-icon>
                  <span
                    color="#6F6E6F"
                    class="filter-button">
                    {{ $t('commonPhrases.clearSelection') }}
                  </span>
                </div>
              </div>
            </template>
          </chart-card>
        </div>
      </DataProvider>
    <!--------------
      TABELA
    --------------->
    <SearchMessagesNotUnderstood :wordcloud='word'/>
  </div>
</template>

<script>
import DataProvider from '@/components/DataProvider'
import SkeletonLoaderChart from '@/components/Reuse/SkeletonLoaderChart'
import CardNoData from '@/components/CardNoData'
import ChartCard from '@/components/Cards/ChartCard'
import { mapFields } from 'vuex-map-fields'

import SearchMessagesNotUnderstood from '@/components/SearchMessagesNotUnderstood/Search.vue'
import wordcloud from 'vue-wordcloud'
import moment from 'moment'

/* eslint-disable */

class TooltipElement {
  constructor () {
    this.style = {
      zIndex: 1,
      position: 'absolute',
      height: '25px',
      width: '90px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;',
      textAlign: 'center',
      lineHeight: '24px',
      color: 'white',
      background: 'rgba(0,0,0,0.6)',
      border: '0px',
      borderRadius: '20px',
      pointerEvents: 'none',
      transition: '0.5s',
      boxShadow: '2px 2px 15px 3px rgba(0,0,0,0.2)',
      display: 'flex',
      flexDirection: 'column-reverse'
    },
    this.element = null
    this.content = ''
    this._autoDestroy = false
    this.x = '0px'
    this.y = '0px'
  }
  setPosition (x, y) {
    this.x = `${x}px`
    this.y = `${y}px`
    return this
  }
  setContent (arrToFilter, wordToFilter) {
    const result = arrToFilter.filter((ele) => ele.text === wordToFilter)
    this.content = result[0].value
    return this
  }
  update () {
    this.element.style.left = this.x
    this.element.style.top = this.y
    this.element.innerHTML = `<span>total: <b>${this.content}</b></span>`
    return this
  }
  create () {
    this.element = document.createElement('div')

    this.element.style.background = this.style.background
    this.element.style.position = this.style.position
    this.element.style.height = this.style.height
    this.element.style.width = this.style.width
    this.element.style.font = this.style.fontFamily
    this.element.style.textAlign = this.style.textAlign
    this.element.style.lineHeight = this.style.lineHeight
    this.element.style.color = this.style.color
    this.element.style.border = this.style.border
    this.element.style.borderRadius = this.style.borderRadius
    this.element.style.pointerEvents = this.style.pointerEvents
    this.element.style.zIndex = this.style.zIndex
    this.element.style.transition = this.style.transition
    this.element.style.boxShadow = this.style.boxShadow
    this.element.style.display = this.style.display
    this.element.style.flexDirection = this.style.flexDirection

    this.update()

    this.element.className = "custom-tooltip"

    document.body.appendChild(this.element)
  }
  delete () {
    this._autoDestroy = false
    if (this.element !== null) {
      document.body.removeChild(this.element)
      this.element = null
    }
  }
  isCreated () { return this.element !== null }
  autoDestroy (value) {
    this._autoDestroy = value
    if(this._autoDestroy === false)
      return
    setTimeout(() => {
      if(this._autoDestroy) {
        this.delete()
      }
    }, 500)
  }
  static deleteAll () {
    const tooltipsFromCloud = document.getElementsByClassName('custom-tooltip')
    for (let i = 0; i < tooltipsFromCloud.length; i++) {
      document.body.removeChild(tooltipsFromCloud[i])
    }
  }
}
const tooltip = new TooltipElement()

export default {
  name: 'MessagesNotUnderstood',
  props: {
    searchList: {
      type: String,
      defalut: ''
    }
  },
  components: {
    DataProvider,
    SkeletonLoaderChart,
    CardNoData,
    ChartCard,
    SearchMessagesNotUnderstood,
    wordcloud
  },
  watch: {
    searchList: {
      handler (value) {
        this.handleSearch(value)
      }
    }
  },
  computed: {
    ...mapFields('reports', ['dateInterval']),
    ...mapFields('wordcloud', ['word'])
  },
  data () {
    return {
      myColors: 'Category10',
      wordsCloud: [],
      wordsToSearch: [],
      filter: {
        from: '',
        to: '',
        filterWords: ''
      }
    }
  },
  methods: {
    wordClickHandler (name) {
      if (!this.wordsToSearch.includes(name)) {
        this.wordsToSearch.push(name)
        this.word = this.wordsToSearch.join(' ')
      }
    },
    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const fromFromatted = moment(from).utcOffset(0, true).format('YYYY-MM-DDTHH:mm:ss')
      const to = this.dateInterval.timestamp2
      const toFormatted = moment(to).utcOffset(0, true).format('YYYY-MM-DDTHH:mm:ss')
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`,
        filter: { to: toFormatted, from: fromFromatted, filterWords: this.wordsToSearch.join(',') }
      }
    },
    async mountChartData (response) {
this.wordsCloud = response.data.wordsCloud
    },
    removeWord (name) {
      this.wordsToSearch = this.wordsToSearch.filter(word => word !== name)
      this.word = this.wordsToSearch.join(' ')
    },
    removeAllWords () {
      this.wordsToSearch = []
      this.word = ''
    }
  },
  mounted () {
    const element = document.getElementById('id-wordcloud')
    element.onmouseleave = (e) => {
      tooltip.autoDestroy(true)
    }
  },
  updated () {
    setTimeout(() => {
      const wordsFromCloud = document.getElementsByClassName('text')

      for (let i = 0; i < wordsFromCloud.length; i++) {
        const element = wordsFromCloud[i]

        element.onmouseenter = (e) => {
          tooltip.autoDestroy(false)
          tooltip.setPosition(e.pageX, e.pageY).setContent(this.wordsCloud, element.innerHTML)
          if(!tooltip.isCreated())
            tooltip.create()
          else
            tooltip.update()
        }
        element.onmouseleave = (e) => {
            tooltip.autoDestroy(true)
        }
      }
    }, 2000)
  }
}
</script>

<style lang="scss" scoped>
.md-layout-item {
  padding-right: 15;
  padding-left: 15;
}
.md-card {
  [class*="md-card-header-"] {
    margin: 0;
  }
}

.chip-filter {
  height: 42px !important;
  padding: 10px 16px;
  border-radius: 8px !important;
  margin-right: 20px;
}

.filter-button {
  text-transform: lowercase;
  font-weight: 300;
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
